<div
  *transloco="let transloco"
  [ngClass]="{
    'flex-col': !(this.props.iconPre || this.props.iconPost)
  }"
  class="flex">
  <p-inputgroup>
    @if (this.props.iconPre) {
      <p-inputgroup-addon>
        <i [class]="this.props.iconPre"></i>
      </p-inputgroup-addon>
    }
    <p-inputNumber
      fluid
      [formlyAttributes]="this.field"
      [formControl]="this.formControl"
      [maxFractionDigits]="this.props.maxFractionDigits || 0"
      [max]="this.props.max ?? 999999999"
      [minFractionDigits]="this.props.minFractionDigits || 0"
      [min]="this.props.min ?? -999999999"
      [showClear]="this.props.readonly == undefined ? this.props.showClear : !this.props.readonly"
      [placeholder]="transloco(this.props.placeholder || '')"
      [mode]="this.props.mode || 'decimal'"
      [ngClass]="{
        'ng-dirty ng-invalid p-invalid': this.showError
      }"
      [prefix]="this.props.prefix || ''"
      [readonly]="this.props.readonly"
      [showButtons]="this.props.showButtons"
      [suffix]="this.props.suffix || ''"
      [useGrouping]="false"
      currency="EUR"
      locale="de-DE">
    </p-inputNumber>
    @if (this.props.iconPost) {
      <p-inputgroup-addon>
        <i [class]="this.props.iconPost"></i>
      </p-inputgroup-addon>
    }
  </p-inputgroup>
</div>
